<template>
  <div class="text-center">
    <p>
      {{
        $t('school.academic.operation.classOperation.teacher_same_confirmation')
      }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'messageConfirm',
  data() {
    return {}
  }
}
</script>
